"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileInputField = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var isDgSuperApp_1 = __importDefault(require("../../app/util/isDgSuperApp"));
var selectFileBase64_1 = __importDefault(require("../helpers/super-app/selectFileBase64"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return core_1.createStyles({
        fileInputWrapper: {
            width: '100%',
            display: 'flex',
            alignItems: 'stretch',
            borderRadius: '8px',
            overflow: 'hidden',
            border: function (props) {
                return props.uploadFileError ? '2px solid #C85151' : '';
            },
        },
        fileNameText: {
            fontWeight: 400,
            paddingLeft: '30px',
            display: 'flex',
            alignItems: 'center',
        },
        fileInputInvis: {
            display: 'none',
        },
        leftFileIcon: {
            width: '44px',
            backgroundColor: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        fileInput: (_a = {
                flexGrow: 1,
                height: '100%',
                minHeight: function (props) { return props.textFieldHeight; },
                padding: theme.spacing(0),
                lineHeight: 1.5,
                backgroundColor: 'none',
                display: 'flex',
                alignItems: 'stretch',
                overflow: 'hidden',
                justifyContent: 'space-between',
                borderRadius: '0px 8px 8px 0px',
                border: '1px solid #11111333'
            },
            _a[theme.breakpoints.up('sm')] = {
            // backgroundColor: '#e8e8e8',
            },
            _a),
        fileSizeText: {
            fontWeight: 400,
            display: 'flex',
            alignItems: 'center',
            paddingRight: theme.spacing(1.5),
        },
        fileInputEndWrapper: {
            display: 'flex',
            alignItems: 'stretch',
        },
        uploadButtonText: {
            padding: 0,
            margin: 0,
            width: '100px',
            height: '100%',
            borderRadius: 0,
            color: theme.palette.background.default,
        },
    });
});
var FileInputField = function (_a) {
    var textFieldHeight = _a.textFieldHeight, _b = _a.fileNameText, fileNameText = _b === void 0 ? '' : _b, _c = _a.fileSizeText, fileSizeText = _c === void 0 ? '' : _c, _d = _a.buttonText, buttonText = _d === void 0 ? '' : _d, setFile = _a.setFile, uploadFileError = _a.uploadFileError, setUploadFileError = _a.setUploadFileError, _e = _a.isUploading, isUploading = _e === void 0 ? false : _e, className = _a.className, _f = _a.acceptedTypes, acceptedTypes = _f === void 0 ? '' : _f, maxSize = _a.maxSize;
    var _g = __read(react_i18next_1.useTranslation(), 1), t = _g[0];
    var classes = useStyles({ textFieldHeight: textFieldHeight, uploadFileError: uploadFileError });
    var handleOnChangeFile = function (chosenFile) {
        if (!chosenFile) {
            return;
        }
        if (chosenFile.size > maxSize) {
            setFile(null);
            setUploadFileError(t('message.error.fileTooLage'));
            return;
        }
        setUploadFileError('');
        setFile(chosenFile);
    };
    var handleOnSuperAppSelectFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var file, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, selectFileBase64_1.default()];
                case 1:
                    file = _a.sent();
                    if (file) {
                        handleOnChangeFile(file);
                    }
                    else {
                        console.log('error');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onChangeFile = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var chosenFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isDgSuperApp_1.default()) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleOnSuperAppSelectFile()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    if (!event.target.files) {
                        return [2 /*return*/];
                    }
                    chosenFile = event.target.files[0];
                    handleOnChangeFile(chosenFile);
                    _a.label = 3;
                case 3:
                    // Clear value so that file event is refired when even if same file is uploaded https://stackoverflow.com/a/60886920
                    // eslint-disable-next-line no-param-reassign
                    event.target.value = '';
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: classes.fileInputWrapper + " " + className },
        react_1.default.createElement("div", { className: classes.fileInputEndWrapper },
            react_1.default.createElement("label", { htmlFor: "file" },
                react_1.default.createElement(core_1.Button, { variant: "contained", className: classes.uploadButtonText, component: "span", color: "primary", disabled: isUploading, onClick: isDgSuperApp_1.default() ? function (event) { return onChangeFile(event); } : undefined }, isUploading ? (react_1.default.createElement(core_1.CircularProgress, { color: "primary", size: 20 })) : (buttonText)))),
        react_1.default.createElement("div", { className: classes.fileInput },
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.fileNameText }, fileNameText),
            react_1.default.createElement("input", { type: "file", id: "file", className: classes.fileInputInvis, onChange: function (event) { return onChangeFile(event); }, accept: acceptedTypes, disabled: isDgSuperApp_1.default() }),
            react_1.default.createElement(core_1.Typography, { variant: "body2", className: classes.fileSizeText }, fileSizeText))));
};
exports.FileInputField = FileInputField;
exports.default = exports.FileInputField;
